import React from 'react';
import { Footer, Header } from '../../components';
import { Col, Img, MainContainer, Row } from 'ui/layout';
import styled from 'styled-components';
import ill2 from 'assets/partners/ill2.png';
import { BREAKPOINTS, COLORS } from '../../utils';
import PDF12 from './obshtie-usloviya-arendy-tehniki-s-ekipazhem-redakciya-1-ot-15-10-2024.70ee59e1c8a6a141d667.pdf';
import PDF22 from './obshtie-usloviya-okazaniya-avtotransportnyh-uslug-redakciya-1-ot-15-10-2024.bb1003ca89c496ab7051.pdf';
import PDF32 from './obshtie-usloviya-arendy-avtomobilnogo-transporta-s-ekipazhem-redakciya-1-ot-15-10-2024.548136976a14b6ff00d9.pdf';
import PDF42 from './obshtie-usloviya-okazaniya-uslug-specialnoj-tehnikoj-redakciya-1-ot-15-10-2024.a55850adf0c8eb475752.pdf';
import { Link } from 'react-router-dom';

export const PartnersPage = () => {
  return (
    <div>
      <Header active={'partners'} />

      <Wrapper>
        <MainContainer>
          <Row alignItems={'flex-start'}>
            <TextCol width={'35%'} xlWidth={'42%'} lgWidth={'100%'}>
              <H1>
                Стать нашим
                <br />
                подрядчиком
                <br />и поставщиком
              </H1>
              <Row marginTop={20} direction='column' gap>
                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF32}
                >
                  1.ОБЩИЕ УСЛОВИЯ аренды автомобильного транспорта с экипажем
                  (редакция №4 от 16.04.2026)
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF12}
                >
                  2.ОБЩИЕ УСЛОВИЯ аренды техники с экипажем (редакция №4 от 16.04.2026)
                </DownloadLink>

                <DownloadLink
                  target='_blank'
                  rel='noopener noreferrer'
                  href={PDF42}
                >
                  3.ОБЩИЕ УСЛОВИЯ оказания услуг специальной техникой (редакция №4 от 16.04.2026)
                </DownloadLink>

                <DownloadLink
                  href={PDF22}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  4.ОБЩИЕ УСЛОВИЯ оказания автотранспортных услуг (редакция №4 от 16.04.2026)
                </DownloadLink>
              </Row>
              <br/>
              <StyledLink to='/partners_archive'>
                Архив
              </StyledLink>
              <FeedbackContainer>
                Обратная связь:{' '}
                <PostLink href='mailto:info@allgk.ru'>info@allgk.ru</PostLink>
              </FeedbackContainer>
            </TextCol>
            <Col width={'65%'} xlWidth={'58%'} lgHidden paddingLeft={3}>
              <Ill2 src={ill2} alt={''} />
            </Col>
          </Row>
        </MainContainer>

        <Ill2Tablet src={ill2} alt={''} />
      </Wrapper>

      <Footer />
    </div>
  );
};

const Wrapper = styled.div`
  position: relative;
  padding-top: 137px;
  padding-bottom: 138px;

  @media (max-width: ${BREAKPOINTS.lg}px) {
    padding-top: 132px;
    padding-bottom: 0;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    padding-top: 55px;
    padding-bottom: 27px;
  }

  :before {
    content: '';
    position: absolute;
    left: -76px;
    top: 0;
    height: 89px;
    width: 100px;
    background: #0c67b1;
    transform: skew(-30deg);
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    :before {
      height: 26px;
      left: -90px;
      top: 32px;
    }
  }
`;
const H1 = styled.h1`
  font-weight: 600;
  font-size: 48px;
  line-height: 58px;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    font-size: 38px;
    line-height: 46px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    font-size: 25px;
    line-height: 30px;
  }
`;

const TextCol = styled(Col)`
  @media (max-width: ${BREAKPOINTS.smd}px) {
    padding-left: 21px;
  }
`;
const FeedbackContainer = styled.div`
  margin-top: 53px;
  min-height: 53px;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    margin-top: 19px;
    max-width: 289px;
  }
  @media (max-width: ${BREAKPOINTS.smd}px) {
    max-width: 205px;
    margin-top: 24px;
  }
`;
const PostLink = styled.a`
  text-decoration: none;
  font-weight: 600;
  color: ${COLORS.primary1};
  :hover {
    opacity: 0.6;
  }
`;
const Ill2 = styled(Img)`
  width: 100%;
  height: 525px;
  object-fit: cover;
`;
const Ill2Tablet = styled(Img)`
  display: none;
  width: 100%;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    display: block;
    margin-top: 136px;
  }
  @media (max-width: ${BREAKPOINTS.lg}px) {
    margin-top: 26px;
  }
`;

const DownloadLink = styled.a`
  margin-bottom: 12px;
  text-decoration: none;
  font-weight: 600;
  color: ${COLORS.primary1};
  cursor: pointer;
  :hover {
    opacity: 0.6;
  }
`;
const StyledLink = styled(Link)`
    margin-bottom: 12px;
    text-decoration: none;
    font-weight: 600;
    color: ${COLORS.primary1};
    cursor: pointer;
    :hover {
        opacity: 0.6;
    }
`;